/** Shared successful-add feedback for cards, native forms and the JD1 Buy Box. */
let popup;
let dismissTimer;
function ensurePopup() {
  if (popup?.isConnected) return popup;
  popup = document.createElement('aside');
  popup.className = 'jd1-cart-feedback';
  popup.hidden = true;
  popup.setAttribute('aria-label', 'Confirmación del carrito');
  popup.innerHTML = `<button type="button" class="jd1-cart-feedback__close" aria-label="Cerrar aviso">×</button>
    <img class="jd1-cart-feedback__image" alt="" width="72" height="72" hidden>
    <div class="jd1-cart-feedback__copy"><div role="status" aria-live="polite" aria-atomic="true"><strong></strong><p></p></div>
    <a class="jd1-cart-feedback__link">VER CARRITO</a></div>`;
  popup.querySelector('button').addEventListener('click', () => { popup.hidden = true; });
  popup.querySelector('a').addEventListener('click', (event) => {
    const drawer = document.querySelector('cart-drawer-component');
    if (!drawer?.open && !drawer?.showDialog) return;
    event.preventDefault();
    popup.hidden = true;
    if (drawer.open) drawer.open(); else drawer.showDialog();
  });
  popup.addEventListener('pointerenter', () => clearTimeout(dismissTimer));
  popup.addEventListener('focusin', () => clearTimeout(dismissTimer));
  const delayClose = () => { clearTimeout(dismissTimer); dismissTimer = setTimeout(() => { popup.hidden = true; }, 7000); };
  popup.addEventListener('pointerleave', delayClose);
  popup.addEventListener('focusout', delayClose);
  document.body.append(popup);
  return popup;
}
export function showCartFeedback(response, source, options = {}) {
  const item = response?.items?.[0] || response;
  if (!item?.id || response?.status) return;
  const node = ensurePopup();
  clearTimeout(dismissTimer);
  const photo = item.image || item.featured_image?.url || source?.querySelector('add-to-cart-component')?.dataset.productVariantMedia;
  const img = node.querySelector('img');
  img.hidden = !photo;
  if (photo) img.src = photo;
  node.querySelector('strong').textContent = options.message || 'Producto agregado al carrito con éxito';
  node.querySelector('p').textContent = options.title || item.product_title || item.title || 'Tu producto';
  node.querySelector('a').href = `${window.Shopify?.routes?.root || '/'}cart`;
  node.hidden = false;
  dismissTimer = setTimeout(() => { node.hidden = true; }, 7000);
}
